import { ApiKeyUser, Delegate, DelegateRole } from "types";
import { DelegateListFilterValues } from "./DelegateListFilter";

const excludedRoles = new Set([DelegateRole.PLUGIN, DelegateRole.BOOKING_ENGINE]);

const hasAllPermissions = (filters: DelegateListFilterValues) =>
    filters.permissions.all || filters.permissions.selected.length === 0;

export const filterRealUsers = (delegates: Delegate[]) => {
    return delegates.filter((delegate) => {
        const isXolaPartner = delegate.permissions.some((permission) => permission.name === DelegateRole.XOLA_PARTNER);
        const hasExcludedRoles =
            delegate.user.email?.includes("plugin+") ||
            delegate.user.roles.some((role) => excludedRoles.has(role as DelegateRole)) ||
            delegate.permissions.some((permission) => permission.name === DelegateRole.BOOKING_ENGINE);
        return !isXolaPartner && !hasExcludedRoles;
    });
};

export const filterDelegatesByFilters = (delegates: Delegate[], filters: DelegateListFilterValues) => {
    const isAllPermissions = hasAllPermissions(filters);
    const isAllStatus = filters.status === "all";

    return delegates.filter((delegate) => {
        const statusFilter =
            isAllStatus ||
            (filters.status === "pending" ? !delegate.user.enabled || delegate.user.newEmail : delegate.user.enabled);
        const permissionFilter =
            isAllPermissions ||
            delegate.permissions.some((permission) => filters.permissions.selected.includes(permission.name));
        return statusFilter && permissionFilter;
    });
};

export const filterApiKeysByFilters = (apiKeys: ApiKeyUser[] = [], filters: DelegateListFilterValues) => {
    if (filters.status === "pending") {
        return [];
    }

    const isAllPermissions = hasAllPermissions(filters);
    return apiKeys.filter((apiKey) => {
        return isAllPermissions || apiKey.roles.some((role) => filters.permissions.selected.includes(role));
    });
};
